export default {
  namespaced: true,
  state: {
    cpa_errors: {}
  },
  getters: {
    cpaErrors: (state, getters) => {
      return state.cpa_errors
    }
  },
  actions: {
    addError({state, commit}, {item, name}) {
      state.cpa_errors[item] = {id: item, name}
    },
    removeError({state, commit}, {item}) {
      delete state.cpa_errors[item]
    },
    reset({state, commit}) {
      state.cpa_errors = {}
    }
  }
}
